import { __assign, __decorate, __extends } from "tslib";
import React from 'react';
import s from './solution-page-header.scss';
import { AddToSite } from '../solution-info';
import { config } from '../../../../config';
import { Origin } from '../../../../enums/marketplace-enums';
import { withMarketplaceStore, } from '../../../../component-decorators/with-marketplace-store';
import { SolutionBadge } from '@wix/app-market-collection-widget';
import { Box, Avatar, Text, Badge } from 'wix-style-react';
import { getClientImageURL } from '../../../../common/getClientImageURL';
import { composer } from '../../../../component-decorators/composer';
import { computed } from 'mobx';
import { getBadgeKeyFromTags, getBadgeTheme, getBundleAppSavedPrice, isBundleAppAndInstalled, isBundleAppAndNotInstalled, } from '../../../../common/utils';
import { withExperiments } from '../../../../component-decorators/with-experiments';
import { withTranslation } from '../../../../component-decorators/with-translation';
import { BackButton } from '../../../back-button';
var SolutionPageHeader = /** @class */ (function (_super) {
    __extends(SolutionPageHeader, _super);
    function SolutionPageHeader(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SolutionPageHeader.prototype, "isAppInstalled", {
        get: function () {
            var _this = this;
            var _a;
            return (_a = this.props.marketplaceStore.installedApps) === null || _a === void 0 ? void 0 : _a.some(function (installedApp) { return installedApp.webSolutionBase.id === _this.props.id; });
        },
        enumerable: false,
        configurable: true
    });
    SolutionPageHeader.prototype.render = function () {
        var solutionPageHeaderContainer = config.origin === Origin.STANDALONE
            ? s.solutionPageHeaderContainerSa
            : s.solutionPageHeaderContainer;
        var bottomTransform = this.props.position === 'bottom'
            ? this.props.show
                ? 'translateY(0%)'
                : 'translateY(100%)'
            : undefined;
        var bottomTransition = this.props.position === 'bottom' ? 'all 0.8s ease-out' : undefined;
        var bottomPosition = this.props.position === 'bottom' ? 0 : undefined;
        var topOpacity = this.props.position === 'top' ? (this.props.show ? 1 : 0) : undefined;
        var appBadgeKey = getBadgeKeyFromTags(this.props.Tags, this.props.experiments);
        var badgeTheme = appBadgeKey ? getBadgeTheme(appBadgeKey) : {};
        var shouldShowBackButton = this.props.marketplaceStore.prevRoute &&
            this.props.marketplaceStore.route.referral !== 'back_button' &&
            this.props.marketplaceStore.route.referral !== 'menu_navigation';
        return (React.createElement(Box, { opacity: topOpacity, transform: bottomTransform, transition: bottomTransition, bottom: bottomPosition, verticalAlign: "middle", className: solutionPageHeaderContainer },
            shouldShowBackButton && (React.createElement(Box, { className: s.headerBack },
                React.createElement(BackButton, { skinColor: 'standard', hideText: true, appId: this.props.id }))),
            React.createElement(Box, { marginLeft: this.props.isMobile && shouldShowBackButton ? '0px' : this.props.isMobile || shouldShowBackButton ? '6px' : '48px', marginRight: '12px' },
                React.createElement(Avatar, { shape: "square", dataHook: "solution-icon-avatar", className: s.headerAvatar, size: "size36", imgProps: {
                        src: getClientImageURL(this.props.icon, {
                            toHeight: 36,
                            toWidth: 36,
                        }),
                        alt: this.props.name + " logo",
                    } })),
            React.createElement(Box, { direction: "vertical", className: s.appTitleAndCompanyContainer },
                React.createElement(Box, null,
                    React.createElement(Text, { size: this.props.isMobile ? "small" : "medium", weight: "bold" }, this.props.name),
                    appBadgeKey && (React.createElement(Box, { marginLeft: '4px', marginTop: '5px' },
                        React.createElement(Badge, __assign({ dataHook: "solution-badge" }, badgeTheme), this.props.t(appBadgeKey))))),
                React.createElement(Box, null,
                    React.createElement(Text, { size: "small" },
                        React.createElement(TranslatedKey, { tkey: 'solution.page.developerName.by' })),
                    React.createElement(Text, { size: "small", className: s.headerDevLink },
                        ' ',
                        this.props.developerName))),
            !this.props.isMobile && React.createElement("div", { className: s.headerBtnAndPricing, style: {
                    flexDirection: this.props.isMobile ? 'column-reverse' : 'initial',
                    alignItems: this.props.isMobile ? 'end' : 'center',
                } },
                React.createElement(SolutionBadgeWrapper, { isInstalled: this.isAppInstalled, showPremiumLabel: this.props.pricing &&
                        this.props.pricing.isRequiredWixPremium &&
                        !this.props.marketplaceStore.siteIsPremium, pricing: this.props.pricing, isBundleAppNotInstalled: isBundleAppAndNotInstalled(this.props.id, this.props.marketplaceStore.bundleApps), isBundleAppInstalled: isBundleAppAndInstalled(this.props.id, this.props.marketplaceStore.bundleApps), savedPrice: getBundleAppSavedPrice(this.props.id, this.props.marketplaceStore.bundleApps), companyId: this.props.companyId }),
                React.createElement("div", { className: s.headerAddToSiteBtn, "data-hook": "btn-install-cta-header" },
                    React.createElement(AddToSite, { addToSiteData: this.props, size: 'small', location: 'sticky_header' })))));
    };
    __decorate([
        computed
    ], SolutionPageHeader.prototype, "isAppInstalled", null);
    SolutionPageHeader = __decorate([
        withMarketplaceStore,
        withExperiments,
        withTranslation
    ], SolutionPageHeader);
    return SolutionPageHeader;
}(React.Component));
export { SolutionPageHeader };
var TranslatedKey = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, tkey = _a.tkey;
    return t(tkey);
});
var SolutionBadgeWrapper = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, isInstalled = _a.isInstalled, showPremiumLabel = _a.showPremiumLabel, pricing = _a.pricing, isBundleAppInstalled = _a.isBundleAppInstalled, isBundleAppNotInstalled = _a.isBundleAppNotInstalled, savedPrice = _a.savedPrice, companyId = _a.companyId;
    return (React.createElement(SolutionBadge, { isInstalled: isInstalled, t: function (k, o) { return t(k, o); }, showPremiumLabel: showPremiumLabel, pricing: pricing, isBundleAppNotInstalled: isBundleAppNotInstalled, isBundleAppInstalled: isBundleAppInstalled, savedPrice: savedPrice, companyId: companyId }));
});
//# sourceMappingURL=solution-page-header.js.map